module.exports = __webpack_public_path__ + "img/whhjh.80a7bcb1.png";